import React from 'react';
import * as PopoverPrimitive from '@radix-ui/react-popover';
import { ExpandCollapseButton } from './ExpandCollapseButton';
import styles from './PlanningDrawer.module.scss';
import { PlanningContext, TRANSLATIONS } from './utils';
import { PrintPdfButton } from './PrintPdfButton';

interface PlanningHeaderProps {
  planningContext: PlanningContext;
  printPdfPath: string;
}

export const PlanningHeader = ({ planningContext, printPdfPath }: PlanningHeaderProps) => (
  <div className={`tw-p-4 tw-border-b tw-border-solid tw-border-med-grey ${styles.header}`}>
    <div className="tw-flex tw-justify-between tw-items-center tw-mb-2">
      <h2 className="tw-p-0 tw-m-0 tw-text-2xl">
        {TRANSLATIONS.title(planningContext)}
      </h2>
      <div className="tw-flex tw-items-center tw-gap-4">
        <ExpandCollapseButton />
        <PrintPdfButton printPdfPath={printPdfPath} />
        <PopoverPrimitive.Close
          aria-label={TRANSLATIONS.dialog.close}
          className="tw-bg-white tw-outline-none tw-border-none tw-text-xl tw-cursor-pointer"
        >
          ✕
        </PopoverPrimitive.Close>
      </div>
    </div>
    <p className="tw-text-dark-grey tw-text-sm tw-mb-0">
      {TRANSLATIONS.visibilityMessage}.
    </p>
  </div>
);
